/* Copyright Verge Technologies 2018
 * @file articles.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing articles
 */

// Modules
import React from 'react';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { ARTICLES_QUERY } from '../../graphql';

// Components
import ArticleCard from '../../components/ArticleCard/articleCard';

const Articles = () => {
  return (
    <div className="applications-container">
      <Query query={ARTICLES_QUERY} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
              <div className="page-heading heading-articles">Articles</div>
              <div className="content-list-container">
                <ul>
                  {data.getArticles.map((article) => {
                    return (
                      <ArticleCard
                        title={article.title}
                        image={article.image}
                        tag={article.tags}
                        slug={article.slug}
                        blurb={article.article_blurb}
                        key={article.slug}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default Articles;



// WEBPACK FOOTER //
// ./src/components/Articles/articles.js